"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigStatusResponseCode = exports.LogoutResponseCode = exports.TokenResponseCode = exports.IdentityProvider = void 0;
var IdentityProvider;
(function (IdentityProvider) {
    IdentityProvider["AX_AUTH"] = "AX_AUTH";
    IdentityProvider["AZURE_AD"] = "AZURE_AD";
    IdentityProvider["GOOGLE"] = "GOOGLE";
    IdentityProvider["AXINOM"] = "AXINOM";
    IdentityProvider["CUSTOM"] = "CUSTOM";
})(IdentityProvider = exports.IdentityProvider || (exports.IdentityProvider = {}));
var TokenResponseCode;
(function (TokenResponseCode) {
    TokenResponseCode[TokenResponseCode["SUCCESS"] = 0] = "SUCCESS";
    TokenResponseCode[TokenResponseCode["NEEDS_LOGIN"] = 1] = "NEEDS_LOGIN";
    TokenResponseCode[TokenResponseCode["ACCOUNT_NOT_ACTIVE"] = 2] = "ACCOUNT_NOT_ACTIVE";
    TokenResponseCode[TokenResponseCode["ERROR"] = 3] = "ERROR";
})(TokenResponseCode = exports.TokenResponseCode || (exports.TokenResponseCode = {}));
var LogoutResponseCode;
(function (LogoutResponseCode) {
    LogoutResponseCode[LogoutResponseCode["SUCCESS"] = 0] = "SUCCESS";
    LogoutResponseCode[LogoutResponseCode["ERROR"] = 1] = "ERROR";
})(LogoutResponseCode = exports.LogoutResponseCode || (exports.LogoutResponseCode = {}));
var ConfigStatusResponseCode;
(function (ConfigStatusResponseCode) {
    ConfigStatusResponseCode["SUCCESS"] = "SUCCESS";
    ConfigStatusResponseCode["TENANT_NOT_ACTIVE"] = "TENANT_NOT_ACTIVE";
    ConfigStatusResponseCode["ENVIRONMENT_NOT_ACTIVE"] = "ENVIRONMENT_NOT_ACTIVE";
    ConfigStatusResponseCode["IDP_MISCONFIGURATION"] = "IDP_MISCONFIGURATION";
    ConfigStatusResponseCode["ERROR"] = "ERROR";
})(ConfigStatusResponseCode = exports.ConfigStatusResponseCode || (exports.ConfigStatusResponseCode = {}));
//# sourceMappingURL=enums.js.map